import { Button, Col, Form as FormAnt, Input, Row, Select, Space } from 'antd';
import { system } from '../../../../../API/TT_ELD/Team/system';
import { useSystem } from '../../../../../Hooks/TT_ELD/Team/System';
import GetSystem from './GetSystem';
import { Spin } from 'antd/es';
import { sendEvent } from '../../../../../Utils/analytics';

const sortList = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

type MyObjectType = {
  [key: string | number]: any;
};

const System = () => {
  const [form] = FormAnt.useForm();
  const { data, refetch, isLoading, isFetching }: MyObjectType = useSystem();

  const onSubmit = async (values: any) => {
    const body: MyObjectType = {};
    let key: string | number;
    let key2: string | number;

    for (key in values) {
      if (typeof data?.[key] === 'object' && !Array.isArray(data?.[key]) && data?.[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) !== JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] !== values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data?.[key] !== values[key]) {
        body[key] = values[key];
      }
    }

    await system.addSystem(body);
    refetch();
    form.resetFields();
    sendEvent(`Add button System page`, `Add button System page `, `Add System `, 1);
  };

  return (
    <div className="mainPage">
      {/* Top Right Refresh */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <Button size="large" onClick={refetch}>
          Refresh
        </Button>
      </div>

      <Spin size="large" spinning={isLoading || isFetching}>
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <FormAnt
            form={form}
            layout="vertical"
            name="form_in_modal"
            onFinish={onSubmit}
            initialValues={{ ...data }}
          >
            <Row gutter={[16, 10]} align="bottom">
              <Col xs={24} sm={12} md={8} lg={4}>
                <FormAnt.Item
                  label="type"
                  name="type"
                  rules={[{ required: true, message: 'Please enter your type!' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Enter your type" allowClear />
                </FormAnt.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={4}>
                <FormAnt.Item
                  label="mode"
                  name="mode"
                  rules={[{ required: true, message: 'Please enter your mode!' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    allowClear
                    placeholder="Select mode"
                    style={{ width: '100%' }} // ✅ 150px emas
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={sortList.map((option: any) => ({
                      value: option.value,
                      label: option.label,
                    }))}
                  />
                </FormAnt.Item>
              </Col>

              <Col
                xs={24}
                sm={12}
                md={4}
                lg={3}
                style={{ display: 'flex', alignItems: 'flex-end' }}
              >
                <FormAnt.Item style={{ marginBottom: 0, width: '100%' }}>
                  <Button type="primary" htmlType="submit" block>
                    Add
                  </Button>
                </FormAnt.Item>
              </Col>
            </Row>
          </FormAnt>

          <GetSystem />
        </Space>
      </Spin>
    </div>
  );
};

export default System;
